/* assets/valor-cart.js
   Lightweight Shopify cart helper (replaces React CartContext)
*/
window.ValorCart = (function () {
  async function getCart() {
    const r = await fetch('/cart.js', { credentials: 'same-origin' });
    if (!r.ok) throw new Error('Failed to load cart');
    return r.json();
  }

  async function addToCart({ variantId, quantity = 1, properties = {} }) {
    const r = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({
        id: variantId,
        quantity,
        properties
      }),
    });
    if (!r.ok) throw new Error('Failed to add to cart');
    return r.json();
  }

  async function changeLine({ line, quantity }) {
    const r = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ line, quantity }),
    });
    if (!r.ok) throw new Error('Failed to change cart');
    return r.json();
  }

  async function removeLine(line) {
    return changeLine({ line, quantity: 0 });
  }

  async function clearCart() {
    const r = await fetch('/cart/clear.js', {
      method: 'POST',
      credentials: 'same-origin'
    });
    if (!r.ok) throw new Error('Failed to clear cart');
    return r.json();
  }

  function cartCount(cart) {
    return (cart && typeof cart.item_count === 'number') ? cart.item_count : 0;
  }

  function cartTotal(cart) {
    // Shopify returns totals in cents
    return (cart && typeof cart.total_price === 'number') ? cart.total_price : 0;
  }

  return {
    getCart,
    addToCart,
    changeLine,
    removeLine,
    clearCart,
    cartCount,
    cartTotal,
  };
})();
